<template>
  <v-container class="px-0 py-0" fluid>
    <v-row dense>
      <v-col>
        <CompanyForm />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import CompanyForm from '@/components/organisms/master/form/CompanyForm'

export default {
  name: 'CompanyPage',

  components: {
    CompanyForm,
  },
}
</script>
